<template>
  <div class="input-content">
    <input
      :id="id"
      v-model="value"
      :type="typeInput"
      class="form-input"
      :class="error ? 'input-error' : ''"
      placeholder=" ">
    <label :for="id" class="form-label transition-fast">{{ label }}</label>
    <span v-if="icon" :class="`fa ${icon}`" />
    <span
      v-if="passwordReveal"
      class="fa fa-eye right"
      :class="{'input-eye-active': typeInput === 'text' }"
      @click="showPassword()" />
    <span v-else class="prefix">{{ prefix }}</span>
  </div>
</template>
<script>
export default {
  name: 'TextInput',
  props: {
    id: { type: String, default: '' },
    label: { type: String, default: '' },
    icon: { type: String, default: '' },
    type: { type: String, default: '' },
    prefix: { type: String, default: '' },
    error: { type: Boolean, default: false },
    passwordReveal: { type: Boolean, default: false }
  },
  data() {
    return {
      value: '',
      typeInput: this.type
    };
  },
  watch: {
    value: {
      handler(val) {
        this.value = val;
        this.$emit('input', val);
      }
    }
  },
  methods: {
    showPassword() {
      if (this.typeInput === 'password') this.typeInput = 'text';
      else this.typeInput = 'password';
    }
  }
};
</script>
<style scoped>
.input-content {
  position: relative;
  margin: auto;
  overflow: hidden;
}
.input-content span.fa, .input-content span.prefix {
  position: absolute;
  bottom: 8px;
  left: 15px;
  margin: auto;
  color: var(--color-moon);
}

.input-content span.fa.right {
  position: absolute;
  bottom: 10px;
  right: 15px;
  left: auto;
  margin: auto;
  color: var(--color-moon);
}

.input-eye-active {
  color: var(--primary) !important;
}

.input-content span.prefix {
  color: var(--color-coal);
  font-size: 14px;
  left: 19px;
}
.input-content span.fa {
  bottom: 10px;
}
  .form-label{
    width: 60%;
    font-family: var(--primary-font);
    font-size: 12px;
    margin: 10px auto;
    position: absolute;
    text-align: left;
    left: 0;
    color: var(--primary);
    bottom: 50%;
    padding-left: 14px;
    width: 100%;
  }
  .form-input {
    font: 400 12px var(--primary-font);
    -webkit-appearance: inherit;
    color: var(--color-nickel);
    font-size: 12px;
    margin: auto;
    padding: 10px;
    padding-left: 40px;
    border-radius: 40px;
    background-color:#EFEFEF;
    border: none;
    width: 100%;
    display: block;
    border-bottom: 1px solid transparent;
    transition: all 0.3s;
    margin-top: 30px;
  }
  .form-input:placeholder-shown + .form-label{
    color: var(--color-moon);
    bottom: 0%;
    padding-left: 40px;
  }
  .form-input:placeholder-shown {
    margin-top: 0px;
  }
  .form-input:focus{
    outline:0px;
  }
  .form-input.input-error, .form-input:invalid{
    border: 1px solid red;
  }
  /* autofill */
  .form-input:-webkit-autofill::first-line,
  .form-input:-webkit-autofill,
  .form-input:-webkit-autofill:hover,
  .form-input:-webkit-autofill:focus,
  .form-input:-webkit-autofill:active{
    font: 400 12px var(--primary-font);
    font-family: var(--primary-font);
    color: var(--color-nickel) !important;
    transition: all 0.3s;
  }
  .form-input:-webkit-autofill + .form-label {
    width: 60%;
    font-family: var(--primary-font);
    font-size: 12px;
    margin: 10px auto;
    position: absolute;
    text-align: left;
    left: 0;
    color: var(--primary);
    bottom: 50%;
    padding-left: 14px;
    width: 100%;
  }
</style>
